/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    CZK: 'CZK',
    EUR: 'EUR',
    USD: 'USD',
    HUF: 'HUF',
    PLN: 'PLN',
    GBP: 'GBP',
    CREDITS: 'CREDITS',
    ENTRY: 'ENTRY',
    NO_CURRENCY: 'NO_CURRENCY',
    MAKE_UP_SESSION: 'MAKE_UP_SESSION',
};
